module.exports = __webpack_public_path__ + "static/media/Artboard2.765ac774.png";